export default "__VITE_ASSET__CCAgiAIZ__"